export const POINTS_TYPES = {
    GET_POINTS: "get_points",
    GET_POINTS_SUCCESS: "get_points_success",
}